import AboutHeroSection from '#/features/about/components/AboutHeroSection'
import AboutSection from '#/features/home/components/AboutSection'
import WhyChooseUsSection from '#/features/about/components/WhyChooseUsSection'
import TeachersSection from '#/features/about/components/TeachersSection'
import AboutTestimonialsSection from '#/features/about/components/AboutTestimonialsSection'
import FaqSection from '#/features/about/components/FaqSection'
import AboutPillarsSection from '#/features/about/components/AboutPillarsSection'
import PageTransition from '#/components/common/PageTransition'

export default function AboutPage() {
  return (
    <PageTransition>
      <main className="relative flex flex-col">
        <AboutHeroSection />
        <AboutSection showButton={false} />
        <WhyChooseUsSection />
        <AboutPillarsSection />
        <TeachersSection />
        <AboutTestimonialsSection />
        <FaqSection />
      </main>
    </PageTransition>
  )
}
